import produce from 'immer';
import {
  ADD_NEW_USER_ACTIONTYPE,
  DELETE_USER_ACTIONTYPE,
  GET_ACTIVE_USER_DETAILS,
  GET_ALL_USER_ACTIONTYPE,
  GET_USER_DETAILS_ACTIONTYPE,
  SET_ACTIVE_USER_UUID_ACTIONTYPE,
  SHOW_OVERVIEW_POPOVER_ACTIONTYPE,
  UPDATE_LABEL_DEFINITION_ACTIONTYPE,
  UPDATE_USER_ACTIONTYPE,
  UPDATE_USER_STATUS_ACTIONTYPE,
} from './actionTypes';
import { RESET_APP_DATA_ACTIONTYPE } from '../../appContainer/actionTypes';

export const initialState = {
  allUsers: [],
  activeUser: '',
};

/* eslint-disable default-case, no-param-reassign */
const usersReducer = produce((draft, action) => {
  switch (action.type) {
    case GET_ALL_USER_ACTIONTYPE.SUCCESS: {
      const usersMap = {};
      const currentUsers = draft.allUsers;
      const newUsers = action.payload || [];
      currentUsers.forEach(user => {
        usersMap[user.uuid] = user;
      });
      newUsers.forEach(user => {
        usersMap[user.uuid] = user;
      });
      draft.allUsers = Object.keys(usersMap).map(userUUID => usersMap[userUUID]);
      break;
    }
    case UPDATE_USER_STATUS_ACTIONTYPE.SUCCESS: {
      const { uuid, newStatus } = action.payload;
      const currentUser = draft.allUsers.find(user => user.uuid === uuid);
      currentUser.isActive = newStatus;
      break;
    }
    case UPDATE_USER_ACTIONTYPE.SUCCESS:
    case UPDATE_LABEL_DEFINITION_ACTIONTYPE.SUCCESS:
    case GET_USER_DETAILS_ACTIONTYPE.SUCCESS:
    case GET_ACTIVE_USER_DETAILS.SUCCESS: {
      const userDetails = action.payload;

      if (!userDetails || !Object.keys(userDetails).length) {
        return;
      }

      const userIndex = draft.allUsers.findIndex(user => user.uuid === userDetails.uuid);

      if (userIndex === -1) {
        draft.allUsers.push(userDetails);
      } else {
        const currentUser = draft.allUsers[userIndex];
        const newUser = { ...currentUser, ...userDetails };
        draft.allUsers.splice(userIndex, 1, newUser);
      }
      break;
    }
    case DELETE_USER_ACTIONTYPE.SUCCESS: {
      const userUUID = action.payload;
      const userIndex = draft.allUsers.findIndex(user => user.uuid === userUUID);

      if (userIndex !== -1) {
        draft.allUsers.splice(userIndex, 1);
      }
      break;
    }
    case SHOW_OVERVIEW_POPOVER_ACTIONTYPE.COMPLETED:
    case SET_ACTIVE_USER_UUID_ACTIONTYPE.COMPLETED: {
      draft.activeUser = action.payload;
      break;
    }
    case ADD_NEW_USER_ACTIONTYPE.SUCCESS: {
      const allUsers = [...draft.allUsers];
      allUsers.push(action.payload);
      draft.allUsers = allUsers;
      break;
    }
    case RESET_APP_DATA_ACTIONTYPE.TRIGGER:
      return initialState;
  }
}, initialState);

export default usersReducer;
